// assets/ce-buy-together.js — carrega complementares, soma total, adiciona tudo
(function () {
  const root = document.querySelector('[data-ce-bt]');
  if (!root || !window.ceCart) return;
  const mode = root.dataset.ceBtMode, limit = Number(root.dataset.ceBtLimit || 2);
  let variants = {};
  try { variants = JSON.parse(root.dataset.ceBtVariants || '{}'); } catch (e) { /* sem mapa: usa o valor renderizado */ }
  let mainVariant = Number(root.dataset.ceBtVariant), mainPrice = Number(root.dataset.ceBtPrice), mainAvailable = true;
  let adding = false;
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const mainPriceEl = root.querySelector('[data-ce-bt-main-price]');
  // O Copenhagen não publica variantChange; o seletor da PDP grava o id em input[name="id"] do form e dispara "change". Lemos esse input (no change e na hora do clique).
  const formInput = () => document.querySelector('form[action*="/cart/add"] input[name="id"]');
  const syncMain = () => {
    const input = formInput();
    const id = input ? Number(input.value) : mainVariant;
    const info = variants[id];
    if (info) {
      mainVariant = id; mainPrice = info.p; mainAvailable = info.a;
      if (mainPriceEl) mainPriceEl.textContent = ceCart.money(info.p);
      // Kit: as unidades extras são do mesmo produto, então acompanham a variante escolhida na página
      root.querySelectorAll('[data-ce-bt-kit-item]').forEach((item) => {
        const cb = item.querySelector('[data-ce-bt-check]');
        if (cb) { cb.dataset.ceBtId = String(id); cb.dataset.ceBtItemPrice = String(info.p); }
        const priceEl = item.querySelector('.ce-bt__price');
        if (priceEl) priceEl.textContent = ceCart.money(info.p);
      });
    }
  };
  const slots = root.querySelector('[data-ce-bt-slots]');
  const totalEl = root.querySelector('[data-ce-bt-total]'), saveEl = root.querySelector('[data-ce-bt-save]'), addBtn = root.querySelector('[data-ce-bt-add]');

  const itemHTML = (p) => {
    const v = p.variants.find((x) => x.available) || p.variants[0];
    const sep = p.featured_image && p.featured_image.includes('?') ? '&' : '?';
    const img = p.featured_image ? `<img class="ce-img-3x4" loading="lazy" src="${p.featured_image}${sep}width=300" alt="">` : '';
    const sel = p.variants.length > 1 ? `<select class="ce-bt__variant" data-ce-bt-variant-select>${p.variants.map((x) => `<option value="${x.id}" data-price="${x.price}" ${x.id === v.id ? 'selected' : ''} ${x.available ? '' : 'disabled'}>${esc(x.title)}</option>`).join('')}</select>` : '';
    return `<label class="ce-bt__item"><input type="checkbox" checked data-ce-bt-check data-ce-bt-id="${v.id}" data-ce-bt-item-price="${v.price}">${img}<span class="ce-bt__info"><span class="ce-bt__brand">${esc(p.vendor)}</span><span class="ce-bt__name">${esc(p.title)}</span><span class="ce-bt__price">${ceCart.money(v.price)}</span>${sel}</span></label>`;
  };
  const selected = () => [...root.querySelectorAll('[data-ce-bt-check]:checked')].map((cb) => ({ id: Number(cb.dataset.ceBtId), quantity: 1, price: Number(cb.dataset.ceBtItemPrice) }));
  const kitTexto = (root.dataset.ceBtKitTexto || '').trim();
  const refresh = () => {
    const sel = selected();
    const sum = mainPrice + sel.reduce((a, i) => a + i.price, 0);
    totalEl.textContent = ceCart.money(sum);
    const n = sel.length + 1;
    addBtn.textContent = mode === 'kit' && kitTexto ? kitTexto : (n > 1 ? `Adicionar os ${n} à sacola` : 'Adicionar à sacola');
    addBtn.disabled = adding || !mainAvailable;
  };

  document.addEventListener('change', (e) => {
    if (e.target.matches && e.target.matches('form[action*="/cart/add"] input[name="id"]')) { syncMain(); refresh(); }
  });

  root.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-ce-bt-variant-select]');
    if (sel) { const cb = sel.closest('.ce-bt__item').querySelector('[data-ce-bt-check]'); const opt = sel.selectedOptions[0]; cb.dataset.ceBtId = opt.value; cb.dataset.ceBtItemPrice = opt.dataset.price; }
    refresh();
  });

  addBtn.addEventListener('click', async () => {
    if (adding) return;
    syncMain();
    if (!mainAvailable) { refresh(); return; }
    const items = [{ id: mainVariant, quantity: 1 }, ...selected().map(({ id, quantity }) => ({ id, quantity }))];
    const merged = Object.values(items.reduce((m, i) => { m[i.id] = m[i.id] || { id: i.id, quantity: 0 }; m[i.id].quantity += i.quantity; return m; }, {}));
    adding = true; addBtn.disabled = true;
    try {
      await ceCart.add(merged, mode === 'kit' ? 'kit' : 'compre-junto');
      if (root.dataset.ceBtEconomia === 'true') {
        const cart = await ceCart.get();
        const disc = (cart.total_discount || 0);
        if (disc > 0) { saveEl.textContent = `você economiza ${ceCart.money(disc)}`; saveEl.hidden = false; }
      }
    } catch (err) { alert(err.message); } finally { adding = false; refresh(); }
  });

  syncMain();
  if (mode === 'complementares' && slots) {
    ceCart.recommendations(root.dataset.ceBtProduct, limit, 'complementary').then((products) => {
      const list = products.filter((p) => p.available && ceCart.paid(p)).slice(0, limit);
      if (list.length) { slots.innerHTML = list.map(itemHTML).join(''); }
      if (!slots.querySelector('.ce-bt__item')) root.hidden = true;
      refresh();
    }).catch(() => { if (!slots.querySelector('[data-ce-bt-check]')) root.hidden = true; refresh(); });
  } else { refresh(); }
})();
